<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-5">
            <sui-module-submodule-select
              ref="smComboFrame0"
              :pageId="this.$options.name"
              :selectedMd="frame0.selectData.COD_MDLE"
              :selectedSmd="frame0.selectData.COD_SMDLE"
              defaultMdOption="select"
              defaultSmdOption="all"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_DOC_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="attachDocumentId"
              v-model.trim="frame0.attachDocumentId"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput($event,'attachDocumentId')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_EXTS')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="fileExtensionName"
              v-model.trim="frame0.fileExtensionName"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearch"
            />
          </div>
        
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_GROUP')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="atthGrpCond"
              :selected="frame0.selectData.COD_ATTH_GRP_SEARCH_COND"
              codeId="COD_ATTH_GRP_SEARCH_COND"
              defaultOption="all"
              :initialSelectedIndex="0"
            />
            <div class="comp_spacing" />
            <sui-text-field
              ref="groupSearchText"
              v-model.trim="frame0.groupSearchText"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput($event,'groupSearchText')"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_ATTH_ITEM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="atthItemCond"
              :selected="frame0.selectData.COD_ATTH_ITEM_SEARCH_COND"
              codeId="COD_ATTH_ITEM_SEARCH_COND"
              defaultOption="all"
              :initialSelectedIndex="0"
            />
            <div class="comp_spacing" />
            <sui-text-field
              ref="itemSearchText"
              v-model.trim="frame0.itemSearchText"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput($event,'itemSearchText')"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRD')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="rangeDate"
              v-model="frame0.range"
              :value="frame0.rangeDate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="dloadHisCond"
              :selected="frame0.selectData.COD_DLOAD_HIS_SEARCH_COND"
              codeId="COD_DLOAD_HIS_SEARCH_COND"
              defaultOption="all"
              :initialSelectedIndex="0"
            />
            <div class="comp_spacing" />
            <!-- </div>
          <div class="col-xs-4"> -->
            <sui-text-field
              ref="histSearchText"
              v-model.trim="frame0.histSearchText"
              :disabled="false"
              :readonly="false"
              maxlength="50"
              @keyup.enter="onSearch"
              @keyup="onKeyUpInput($event,'histSearchText')"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="$options.name"
            type="button"
            class="comm_btn_Scr"
            @click="onSearch"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :multiselect="false"
        :dataset="'dsDownloadHist'"
        :showDisplayCountControl="false"
        :columns="gridColumns0"
        :initial-pagesize="10"
      >
        <div class="btn_wrapR">
          <sui-button
            v-permission:download="$options.name"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onClickExcelDown"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div>
      </sui-grid>
      <div
        class="btn_moreView"
        @click="onAddList"
      >
        <p :class="paging.totalCount === 0 || paging.count === paging.totalCount ? 'disabled' : ''">
          {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
        </p>
      </div>
    </sui-page-contents>

    <sui-popup
      v-model="isShownPopup"
      :title="$t('MSG_TIT_DLOAD_RSN')"
    >
      <p01
        :pageId="this.$options.name"
        :fileDownloadReasonContent="fileDownloadReasonContent"
        @onClickClose="onClickClose('isShownPopup')"
      />
    </sui-popup>
  </sui-page>
</template>
<script>
import p01 from './components/PGE_CMD_00009_P01';
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';

const dateFields = [
  'firstRegistrationDTM',
  'finalModificationDTM',
  'pageUsePriodStartDatetime',
  'pageUsePriodFinishDatetime',
  'fileDownloadDTM',
];
export default {
  name: 'PGE_CMD_00009', // eslint-disable-line vue/name-property-casing
  components: { p01 },
  extends: BasePage,
  data() {
    return {
      ispaging: false,
      paging: {
        pagePerCount: 5000,
        currentPage: 1,
        totalCount: 0,
        count: 0,
      },
      frame0: {
        selectData: {
          COD_MDLE: {
            label: '',
            key: '',
          },
          COD_SMDLE: {
            label: '',
            key: '',
          },
          COD_ATTH_GRP_SEARCH_COND: {
            label: '',
            key: '',
          },
          COD_ATTH_ITEM_SEARCH_COND: {
            label: '',
            key: '',
          },
          COD_DLOAD_HIS_SEARCH_COND: {
            label: '',
            key: '',
          },
          COD_EXTS: {
            label: '',
            key: '',
          },
        },
        rangeDate: { to: utils.now('YYYY-MM-DD'), from: utils.now('YYYY-MM-01') },
        range: { to: utils.now('YYYY-MM-DD'), from: utils.now('YYYY-MM-01') },
        attachDocumentId: '',
        groupSearchText: '',
        itemSearchText: '',
        histSearchText: '',
        fileExtensionName: '',
      },
      isShownPopup: false,
      fileDownloadReasonContent: '',
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
        width: '100px',
      }, {
        text: this.$t('MSG_TXT_ATTH_DOC_ID'),
        datafield: 'attachDocumentId',
      }, {
        text: this.$t('MSG_TXT_ATTH_GRP_ID'),
        datafield: 'attachGroupId',
      }, {
        text: this.$t('MSG_TXT_ATTH_GRP_NM'),
        datafield: 'attachGroupName',
      }, {
        text: this.$t('MSG_TXT_ATTH_ITEM_NM'),
        datafield: 'attachItemName',
      }, {
        text: this.$t('MSG_TXT_FILE_NM'),
        datafield: 'fileName',
      }, {
        text: this.$t('MSG_TXT_DOWN_USER'),
        datafield: 'fileDownloadUserId',
        width: '200px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              loginId: 'loginId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.dsDownloadHist, this.$refs.grid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_DOWN_DTM'),
        datafield: 'fileDownloadDTM',
        width: '150px',
      }],
    };
  },
  computed: {
    showMoreCount() {
      return `(${this.paging.count}/${this.paging.totalCount})`;
    },
  },
  watch: {},
  datasets: [{
    id: 'dsDownloadHist',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'originalFinalModificationDTM', map: 'originalFinalModificationDTM' },
      { type: 'string', name: 'fileDownloadSN', map: 'fileDownloadSN' },
      { type: 'string', name: 'fileUid', map: 'fileUid' },
      { type: 'string', name: 'fileName', map: 'fileName' },
      { type: 'string', name: 'fileExtensionName', map: 'fileExtensionName' },
      { type: 'string', name: 'attachDocumentId', map: 'attachDocumentId' },
      { type: 'string', name: 'attachItemId', map: 'attachItemId' },
      { type: 'string', name: 'attachGroupId', map: 'attachGroupId' },
      { type: 'string', name: 'moduleCode', map: 'moduleCode' },
      { type: 'string', name: 'subModuleCode', map: 'subModuleCode' },
      { type: 'string', name: 'fileDownloadReasonContent', map: 'fileDownloadReasonContent' },
      { type: 'string', name: 'fileDownloadUserId', map: 'fileDownloadUserId' },
      { type: 'string', name: 'fileDownloadDTM', map: 'fileDownloadDTM' },
      { type: 'string', name: 'moduleName', map: 'moduleName' },
      { type: 'string', name: 'subModuleName', map: 'subModuleName' },
      { type: 'string', name: 'attachGroupName', map: 'attachGroupName' },
      { type: 'string', name: 'attachItemName', map: 'attachItemName' },
      { type: 'object', name: 'buttonList', map: 'buttonList' },
      { type: 'string', name: 'loginId', map: 'loginId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
      { type: 'string', name: 'displayLanguageId', map: 'displayLanguageId' },
      { type: 'string', name: 'excelFileDownUserName', map: 'excelFileDownUserName' },
    ],
  }],
  methods: {
    /**
     * 다운로드 이력 목록 조회
     */
    onSearch() {
      if (this.onClickValidate()) return false;
      // if (!this.validCheck()) return false;

      const toDate = utils.dateformatToServer(this.frame0.range.to).substr(0 , 8) + '235959';
      const fromDate = utils.dateformatToServer(this.frame0.range.from);
      const queryParams = {
        searchAttachGroupCondition: this.frame0.selectData.COD_ATTH_GRP_SEARCH_COND.key,
        searchAttachItemCondition: this.frame0.selectData.COD_ATTH_ITEM_SEARCH_COND.key,
        searchCondition: this.frame0.selectData.COD_DLOAD_HIS_SEARCH_COND.key,
        moduleCode: this.frame0.selectData.COD_MDLE.key,
        subModuleCode: this.frame0.selectData.COD_SMDLE.key,
        attachDocumentId: this.frame0.attachDocumentId,
        attachGroupId: this.frame0.groupSearchText,
        attachGroupName: this.frame0.groupSearchText,
        attachItemId: this.frame0.itemSearchText,
        attachItemName: this.frame0.itemSearchText,
        fileName: this.frame0.histSearchText,
        fileDownloadUserId: this.frame0.histSearchText,
        fileDownloadToDTM: toDate,
        fileDownloadFromDTM: fromDate,
        fileExtensionName: this.frame0.fileExtensionName,
      };

      this.queryParams = utils.clone(queryParams);

      this.paging.currentPage = 1;
      this.paging.totalCount = 0;
      this.paging.count = 0;

      this.dsDownloadHist.setRawData([], { preventBackup: true });
      this.selectDownHist();
    },
    selectDownHist(){
       utils.assign(this.queryParams, { currentPage: this.paging.currentPage });
       http.request(this.$options.name, 'DTS_CMD_00018', {
        query: this.queryParams,
      }).then(res => {
        if (utils.isUndefined(res.data) === false && res.data.length === this.paging.pagePerCount) {
          this.ispaging = true;
        } else {
          this.ispaging = false;
        }

        if (res.data.length > 0) {
          this.paging.totalCount = res.data[0].totalCount;
        }

        utils.dateformatToClientInArray(res.data, dateFields);

        utils.forEach(res.data, (obj, key) => {
          // row 이력 조회 버튼 정보 생성
          res.data[key].buttonList = [{
            label: this.$t('MSG_BTN_SRCH'),
            key: obj.fileDownloadReasonContent,
            type: 'positive',
          }];
          // 엑셀다운로드용 수정자 컬럼 생성
          const userName = utils.isEqual(this.$store.getters.userInfo.langId, 'ko') ? obj.userName : obj.userGlobalName;
          res.data[key].excelFileDownUserName = `${userName}/${obj.knoxId}`;
        });

        // this.dsDownloadHist.setRawData(res.data); // 데이터 셋에 데이터를 넣는 함수
        const { data } = this.dsDownloadHist;
        const newData = [];
        utils.forEach(data, row => newData.push(row));
        utils.forEach(res.data, row => newData.push(row));
        this.dsDownloadHist.setRawData(newData, { preventBackup: true });

        this.paging.count = this.dsDownloadHist.data.length;
      });
    },
    /**
     * 더보기
     */
    onAddList() {
      if (this.ispaging) {
        this.paging.currentPage += 1;
        this.selectDownHist();
      }
    },
    /**
     * 리셋
     */
    onReset() {
      utils.forEach(this.frame0, (value, key) => {
        switch (key) {
          case 'rangeDate':
            this.frame0[key] = { to: utils.now('YYYY-MM-DD'), from: utils.now('YYYY-MM-01') };
            break;
          case 'range':
            this.frame0[key] = { to: utils.now('YYYY-MM-DD'), from: utils.now('YYYY-MM-01') };
            break;
          case 'selectData':
            // this.$refs.smComboFrame0.reset();
            this.frame0.selectData.COD_MDLE.key = ' ';
            this.frame0.selectData.COD_SMDLE.key = 'ALL';
            this.$refs.dloadHisCond.reset();
            this.$refs.atthItemCond.reset();
            this.$refs.atthGrpCond.reset();
            break;
          default:
            this.frame0[key] = '';
            break;
        }
      });
    },
    
    /**
     *  엑셀 다운로드
     */
    onClickExcelDown() {
      if(this.dsDownloadHist.data.length > 10000 ) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CNT_NOT_EXCEL_DOWN'), 10000));
        return;
      }
      const columns = [{
        text: this.$t('MSG_TXT_MDLE'),
        datafield: 'moduleName',
      }, {
        text: this.$t('MSG_TXT_SMDLE'),
        datafield: 'subModuleName',
      }, {
        text: this.$t('MSG_TXT_ATTH_DOC_ID'),
        datafield: 'attachDocumentId',
      }, {
        text: this.$t('MSG_TXT_ATTH_GRP_ID'),
        datafield: 'attachGroupId',
      }, {
        text: this.$t('MSG_TXT_ATTH_GRP_NM'),
        datafield: 'attachGroupName',
      }, {
        text: this.$t('MSG_TXT_ATTH_ITEM_NM'),
        datafield: 'attachItemName',
      }, {
        text: this.$t('MSG_TXT_FILE_NM'),
        datafield: 'fileName',
      }, {
        text: this.$t('MSG_TXT_DOWN_USER'),
        datafield: 'excelFileDownUserName',
      }, {
        text: this.$t('MSG_TXT_DOWN_DTM'),
        datafield: 'fileDownloadDTM',
      }, {
        text: this.$t('MSG_TXT_RSN'),
        datafield: 'fileDownloadReasonContent',
      }];

      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `downloadHistory_${sToday}.xlsx`;
      utils.downloadGridToExcel(this.$options.name, columns, this.dsDownloadHist, sExcelName);
    },
    /**
     * 다운로드 사유 조회
     */
    onGridButtonClicked(event) {
      this.fileDownloadReasonContent = event.key;
      this.isShownPopup = true;
    },
    onClickClose(key) {
      this[key] = false;
    },
    /**
     * rangeDate Picker 유효성 체크
     */
    validCheck() {
      const toIsNull = utils.isUndefined(this.$refs.rangeDate.range.to);
      const fromIsNull = utils.isUndefined(this.$refs.rangeDate.range.from);

      if (!utils.isEqual(toIsNull, fromIsNull)) {
        utils.messageBox('warning', this.$t('MSG_ALT_DATE_NOT_VAL'));
        return false;
      }

      return true;
    },
    /**
     * 검색조건 특수문자 입력제한
     */
    onKeyUpInput(event, name) {
      const searchFieldNewText = this.frame0[name];

      if (utils.isExistSpecialChar(searchFieldNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR_SRCH'), this.$t('MSG_ALT_SPECL_CHAR_LIST'), () => {
          this.frame0[name] = this[name];
          this.$refs[name].setFocus();
        });
      } else {
        this[name] = searchFieldNewText;
      }
    },
    /* 달력의 오류를 확인할 수 있는 validate 함수 */
    onClickValidate() {
      // if (this.onClickValidate()) return false;
      if (utils.isEmpty(utils.trim(this.frame0.selectData.COD_MDLE.key))) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_IS_SELCT'), this.$t('MSG_TXT_MDLE')), null, null);
        return true;
      }
      if (utils.isEmpty(this.frame0.range.to) || utils.isEmpty(this.frame0.range.from)) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_CHK_NCSR'), this.$t('MSG_TXT_PRD')), null, null);
        return true;
      }
      if (!this.$refs.rangeDate.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return true;
      }
      return false;
    },
  },
};
</script>
<style scoped>
</style>
